import React, { useState } from "react";
import {
  InputAdornment,
  Box,
  Stack,
  styled,
  TextField,
  SearchIcon,
} from "convertupleads-theme";
import ElementList from "./ElementList";
import SearchedElement from "./SearchedElement";
import { ALL_DATA_LISTS } from "../../helpers/sidebarListConstant";

const SidebarWrapper = styled(Stack)(({ theme }) => ({
  width: "320px",
  height: "100%",
  padding: theme.spacing(1),
  borderRight: `1px solid ${theme.palette.other.outlinedBorder}`,
  overflowY: "auto",
  gap: theme.spacing(2),
}));

const Sidebar = () => {
  const [filteredData, setFilteredData] = useState("");

  const handleSearch = (query) => {
    const leafItems = [];

    function traverse(items) {
      for (const item of items) {
        if (!item.subMenu || item.subMenu.length === 0) {
          if (item.title.toLowerCase().includes(query.toLowerCase())) {
            leafItems.push(item);
          }
        } else {
          traverse(item.subMenu);
        }
      }
    }
    traverse(ALL_DATA_LISTS);
    setFilteredData(query === "" ? "" : leafItems);
  };

  return (
    <SidebarWrapper>
      <Box p={1}>
        <TextField
          fullWidth
          onChange={(e) => handleSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize={"small"}/>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          placeholder={"search here..."}
        />
      </Box>
      <Stack spacing={1}>
        {filteredData === "" && <ElementList />}
        {filteredData !== "" && <SearchedElement query={filteredData} />}
      </Stack>
    </SidebarWrapper>
  );
};

export default Sidebar;
